import React, { useCallback, useState } from 'react';

import AssetService from '../../../shared/services/AssetService';
import Backdrop from '@mui/material/Backdrop';
import ChangeFile from '../../../shared/components/ChangeFile';
import DefaultImage from '../../images/default-image.jpg';
import { ImageComponent } from '../../models/LessonComponent';
import { WithCaption } from './WithCaption';
import styles from '../../styles/Image.scss';
import { useLessonContext } from '../../models/LessonContext';

interface ImageProps {
  component: ImageComponent;
}

export function Image(props: ImageProps) {
  const [zoomedIn, setZoomedIn] = useState(false);
  const getClassName = useCallback(() => {
    return props.component.settings.zoom
      ? zoomedIn
        ? styles.zoomOut
        : styles.zoomIn
      : styles.noZoom;
  }, [props.component.settings.zoom, zoomedIn]);

  const { mode } = useLessonContext();

  const handleImageClick = () => {
    if (!props.component.settings.zoom) {
      return;
    }
    setZoomedIn(!zoomedIn);
  };

  const url = AssetService.getAssetUrl(props.component.settings.assetkey);
  return (
    <>
      <WithCaption {...props}>
        <div className={styles.imageContainer}>
          <img
            className={`${getClassName()} ${styles.img}`}
            src={url || DefaultImage}
            onClick={handleImageClick}
          />
          {mode === 'edit' && (
            <ChangeFile
              component={props.component}
              assetkey={props.component.settings.assetkey}
              assetTypes={['image']}
            />
          )}
        </div>
      </WithCaption>
      <Backdrop
        sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })}
        open={zoomedIn}
        onClick={handleImageClick}
      >
        <img className={`${getClassName()} ${styles.zoomedImg}`} src={url} />
      </Backdrop>
    </>
  );
}
